module.exports = __webpack_public_path__ + "img/QW4104x6SD.8b49a1d8.jpg";